export const GET_ERRORS = 'GET_ERRORS';
export const SET_CURRECT_USER = 'SET_CURRECT_USER';
export const GET_PROFILE = 'GET_PROFILE';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const VALIDATE_TOKEN = 'VALIDATE_TOKEN';
export const LOCALE_SET = 'LOCALE_SET';
export const CLOSE_VIDEO_SET = 'CLOSE_VIDEO_SET';
export const SEARCH = 'SEARCH';

export const CLEAR_CURRENT_COMPANY = 'CLEAR_CURRECT_COMPANY';
export const CLEAR_COMPANY_ITEM = 'CLEAR_COMPANY_ITEM';
export const GET_COMPANY = 'GET_COMPANY';
export const GET_COMPANY_ITEM = 'GET_COMPANY_ITEM';
export const GET_COMPANIES = 'GET_COMPANIES';
export const COMPANY_LOADING = 'COMPANY_LOADING';
export const COMPANY_NOT_FOUND = 'COMPANY_NOT_FOUND';
export const GET_COMPANY_FOR_REVIEW = 'GET_COMPANY_FOR_REVIEW';
export const PUBLISH_COMPANY = 'PUBLISH_COMPANY';
export const PUBLISH_COMPANY_NO_UPDATE = 'PUBLISH_COMPANY_NO_UPDATE';
export const EMAIL_COMPANY_SENT = 'EMAIL_COMPANY_SENT';

export const GET_PRODUCT = 'GET_PRODUCT';
export const GET_PRODUCT_ITEM = 'GET_PRODUCT_ITEM';
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_COMPANY_PRODUCTS = 'GET_COMPANY_PRODUCTS';
export const PRODUCT_LOADING = 'PRODUCT_LOADING';
export const PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND';
export const GET_PRODUCT_FOR_REVIEW = 'GET_PRODUCT_FOR_REVIEW';
export const PUBLISH_PRODUCT = 'PUBLISH_PRODUCT';
export const PUBLISH_PRODUCT_NO_UPDATE = 'PUBLISH_PRODUCT_NO_UPDATE';
export const CLEAR_CURRENT_PRODUCT = 'CLEAR_CURRECT_PRODUCT';
export const CLEAR_PRODUCT_ITEM = 'CLEAR_PRODUCT_ITEM';
export const EMAIL_PRODUCT_SENT = 'EMAIL_PRODUCT_SENT';

export const GET_SETTINGS = 'GET_SETTINGS';
export const SETTINGS_LOADING = 'SETTINGS_LOADING';

export const GET_INFOS = 'GET_INFOS';
export const GET_NEW_INFO = 'GET_NEW_INFO';
export const GET_DELETED_INFO = 'GET_DELETED_INFO';
export const INFOS_LOADING = 'INFOS_LOADING';

export const GET_HOME_IMAGES = 'GET_HOME_IMAGES';
export const GET_NEW_HOME_IMAGE = 'GET_NEW_HOME_IMAGE';
export const GET_DELETED_HOME_IMAGE = 'GET_DELETED_HOME_IMAGE';
export const HOME_IMAGES_LOADING = 'HOME_IMAGES_LOADING';

